import { c as _c } from "react/compiler-runtime";
import { PredictBlockNumbersResponseApiModel } from "@/app/tools/block-finder/page.client";
import BlockPickerResultHeader from "./BlockPickerResultHeader";
import BlockPickerResultTable from "./BlockPickerResultTable";
export default function BlockPickerResult(t0) {
  const $ = _c(8);
  const {
    blocknumber,
    timestamp,
    predictedBlocks
  } = t0;
  let t1;
  if ($[0] !== blocknumber || $[1] !== timestamp) {
    t1 = !!blocknumber && !!timestamp && <BlockPickerResultHeader blocknumber={blocknumber} timestamp={timestamp} />;
    $[0] = blocknumber;
    $[1] = timestamp;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== predictedBlocks) {
    t2 = !!predictedBlocks.length && <BlockPickerResultTable predictedBlocks={predictedBlocks} />;
    $[3] = predictedBlocks;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}